export const HOME_FETCH = 'home_fetch'
export const PROPERTY_DETAIL_FETCH = 'property_detail_fetch'
export const AUTH_FETCH = 'authorization_fetch'
